module.exports = __webpack_public_path__ + "media/images/flags/32/Cocos-Keeling-Islands-0d424653ba2d623606fe26f377fed4d5.png";